<template>
  <el-card class="card-box">
    <!--    <el-col class="validate-box" :span="8">-->
    <!--      <span class="iconfont iconmobile"></span>-->
    <!--      <h3>手机验证码认证</h3>-->
    <!--      <p>当前手机号：{{ user.mobile }}</p>-->
    <!--      <el-form ref="form" :model="form" :rules="rules" label-width="0">-->
    <!--        <el-form-item prop="code">-->
    <!--          <el-input-->
    <!--            placeholder="请输入验证码"-->
    <!--            v-model="form.code"-->
    <!--            class="input-with-select"-->
    <!--          >-->
    <!--            <el-button-->
    <!--              style="border-radius:0;width:104px;padding:9px 0;"-->
    <!--              slot="append"-->
    <!--              :class="codeBtnDisable ? 'info' : 'primary'"-->
    <!--              class="code"-->
    <!--              @click="sendCode"-->
    <!--              >{{ msg }}</el-button-->
    <!--            >-->
    <!--          </el-input>-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->

    <!--      <el-button-->
    <!--        class="check-btn"-->
    <!--        round-->
    <!--        @click="checkCode"-->
    <!--        :type="form.code ? 'primary' : 'info'"-->
    <!--        >提交认证</el-button-->
    <!--      >-->
    <!--    </el-col>-->
    <form-modal :show.sync="showModal" @on-submit="save"></form-modal>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import md5 from "md5";
import { CONST_PASSWORD_SLOT } from "@/config/constant";
import CustomizeForm from "@/components/customize-form";
import FormModal from "./components/form-modal";
import auth from "@/api/auth";
import { clearInterval } from "timers";
export default {
  data() {
    return {
      showModal: true,
      msg: "获取验证码",
      codeBtnDisable: false,
      form: {
        code: "",
      },
      rules: {
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  components: {
    FormModal,
  },
  methods: {
    // 保存更改
    save(newPassword) {
      auth
        .changePasswordDirect({
          newPassword: md5(newPassword + CONST_PASSWORD_SLOT).toLowerCase(),
        })
        .then((res) => {
          if (res.value) {
            this.showModal = false;
            this.$message({
              message: "更改成功,返回登录页",
              duration: 1000,
              onClose: () => {
                this.$store.dispatch("logOut").then((res) => {
                  window.location.href = "/login";
                });
              },
            });
          } else {
            this.$message.error("更改失败");
          }
        })
        .catch((res) => {
          this.$message.error("更改失败");
        });
    },
    // 发送验证码
    sendCode() {
      if (this.codeBtnDisable) {
        return false;
      }
      const mobile = this.user.mobile;
      let i = 120;
      let timer = window.setInterval(() => {
        i--;
        this.codeBtnDisable = true;
        this.msg = i + "S 重新获取";
        if (i <= 0) {
          this.msg = "获取验证码";
          this.codeBtnDisable = false;
          window.clearInterval(timer);
        }
      }, 1000);
      auth
        .sendMsgForUpdatePassword({
          cellphone: mobile,
        })
        .then((res) => {
          this.$message.success("验证发送成功");
        });
    },
    // 验证验证码
    checkCode() {
      const mobile = this.user.mobile;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          auth
            .checkMsgForUpdatePassword({
              cellphone: mobile,
              validateCode: this.form.code,
            })
            .then((res) => {
              if (res.value) {
                this.showModal = true;
              } else {
                this.$message.error("验证码过期或错误");
              }
            });
        } else {
          return false;
        }
      });
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>

<style lang="scss" scoped>
.card-box {
  min-height: 400px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .validate-box {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    .iconmobile {
      font-size: 64px;
      color: #3399ff;
    }
    .code {
      background-color: #3399ff;
      color: #ffffff;
    }
    .info {
      background-color: #8a9199;
    }
    .check-btn {
      width: 104px;
      margin: 20px auto;
    }
  }
}
</style>
